<template>
  <div>
    <div class="topicpathHead">
      <div class="left">
        <ul class="topicpath pc">
          <li v-for="(item, index) of breadcrumb" :key="index" :class="{ root: index === 0 }">
            <router-link v-if="item.link" :to="item.link">{{item.name}}</router-link>
            <span v-else>{{item.name}}</span>
          </li>
        </ul>
        <p class="categoryTitle sp">{{ spTitleMenu() }}</p>
      </div>
      <div class="right">
        <ShareButton ulClassName="snsShareBtn" />
      </div>
    </div><!-- /topicpathHead-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShareButton from '@/components/modules/ShareButton'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    ShareButton
  },
  data () {
    return {
      breadcrumb: [
        {
          name: 'トップページ',
          link: '/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersById',
      'specialExhibitionById',
      'breadcrumbList',
      'areas'
    ]),
    shareUrl () {
      return encodeURI(location.href)
    },
    shareTitle () {
      return encodeURI(document.title)
    }
  },
  watch: {
    '$route.path': function (val, oldVal) {
      this.changePath()
    }
  },
  methods: {
    spTitleMenu () {
      if (this.breadcrumb && this.breadcrumb.length > 1) {
        return this.breadcrumb[1].name
      } else {
        return ''
      }
    },
    changePath () {
      const pathList = this.$route.path.split('/')
      this.breadcrumb = [{ link: '/', name: 'トップページ' }]

      // 第1階層
      if (this.$route.path.indexOf('/exhibitors') === 0) {
        this.breadcrumb.push({ link: '/exhibitors', name: '展示者一覧' })
      } else if (this.$route.path.indexOf('/artworks') === 0) {
        this.breadcrumb.push({ link: '/artworks', name: '作品展示' })
      } else if (this.$route.path.indexOf('/specials') === 0) {
        this.breadcrumb.push({ link: '/specials', name: '特別展示' })
      } else if (this.$route.path.indexOf('/talkshows') === 0) {
        this.breadcrumb.push({ link: '/talkshows', name: 'オンライントークショー' })
      } else if (this.$route.path.indexOf('/photobook') === 0) {
        this.breadcrumb.push({ link: '/photobook', name: '公式写真集' })
      } else if (this.$route.path.indexOf('/updateinfo') === 0) {
        this.breadcrumb.push({ link: '/updateinfo', name: 'アップデート情報' })
      }
      if (pathList.length >= 3) {
        // 第2,3階層
        // 第2階層
        if (this.$route.path.indexOf('/specials/') === 0) {
          const specialExhibition = this.specialExhibitionById(pathList[2])
          if (specialExhibition) {
            this.breadcrumb.push({ link: `/specials/${pathList[2]}`, name: specialExhibition.name })
          }
        } else if (this.$route.path.indexOf('/artworks/') === 0) {
          const winner = this.winnersById(pathList[3])
          if (winner) {
            if (this.$route.path.indexOf('/artworks/Tcc10Sen') === 0) {
              // 10選トップ
              const year = pathList[3].substring(0, 4)
              if (year === '2013') {
                this.breadcrumb.push({ link: `/artworks/${pathList[2]}/${year}02`, name: `10選${year}` })
              } else {
                this.breadcrumb.push({ link: `/artworks/${pathList[2]}/${year}01`, name: `10選${year}` })
              }
              // 10選人
              this.breadcrumb.push({ link: `/artworks/${pathList[2]}/${pathList[3]}`, name: winner.name })
            } else if (this.$route.path.indexOf('/artworks/Japan100Views/') === 0) {
              // 100景トップ
              this.breadcrumb.push({ link: '/artworks/Japan100Views/100001', name: '日本写真100景' })
              // 100景人
              if (this.areas) {
                let currentArea = this.areas[0]
                const winnerArea = this.prefecturesMap[winner.winningWorks[0].title]
                for (let i = 0; i < this.areas.length; i++) {
                  if (this.areas[i].name === winnerArea) {
                    currentArea = this.areas[i]
                  }
                }
                this.breadcrumb.push({ link: `/artworks/Japan100Views/${currentArea.id}`, name: currentArea.name })
              }
              this.breadcrumb.push({ link: `/artworks/Japan100Views/${pathList[3]}`, name: winner.name })
            } else if (this.$route.path.indexOf('/artworks/MyPrecious/') === 0) {
              // 大切な存在フォトコン
              this.breadcrumb.push({ link: '/artworks/MyPrecious/200004', name: '"My Precious" Photo Contest' })
              // 大切な存在フォトコン部門
              if ([200004, 200009, 200008, 200006, 200007].indexOf(winner.id) >= 0) {
                this.breadcrumb.push({ link: '/artworks/MyPrecious/200004', name: '「大切なあの人」部門' })
              } else if ([200003, 200010, 200002, 200001, 200005].indexOf(winner.id) >= 0) {
                this.breadcrumb.push({ link: '/artworks/MyPrecious/200003', name: '「愛しい生きもの」部門' })
              }
              // 大切な存在フォトコン人
              this.breadcrumb.push({ link: `/artworks/MyPrecious/${pathList[3]}`, name: winner.name })
            }
          }
        } else if (this.$route.path.indexOf('/talkshows/report_fujifilm') === 0) {
          // トークショーレポート富士フイルム
          this.breadcrumb.push({ link: '/talkshows/report', name: 'トークショーレポート：富士フイルム株式会社' })
        } else if (this.$route.path.indexOf('/talkshows/report_nikon') === 0) {
          // トークショーレポートニコン
          this.breadcrumb.push({ link: '/talkshows/report', name: 'トークショーレポート：ニコンイメージングジャパン' })
        } else if (this.$route.path.indexOf('/talkshows/report') === 0) {
          // トークショーレポート
          this.breadcrumb.push({ link: '/talkshows/report', name: 'トークショーレポート' })
        } else if (this.$route.path.indexOf('/photobook/') === 0) {
          // 公式写真集
          if (this.$route.path.indexOf('/photobook/talkshow') === 0) {
          // 公式写真集オンライントークショー
            this.breadcrumb.push({ link: '/photobook/talkshow', name: '発売記念オンライントークショー' })
          } else if (this.$route.path.indexOf('/photobook/exhibition') === 0) {
          // 公式写真集作品展示
            this.breadcrumb.push({ link: '/photobook/exhibition', name: '10選2019プリント作品展示' })
          }
        }
      }
    }
  },
  mounted () {
    // パス再表示
    this.changePath()

    // winnersのvuexへの読み込み状態を監視し、読み込まれた場合も再表示できるようにする
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setAreas') {
        this.changePath()
      }
    })
  }
}
</script>
